import React from 'react';
import { Grid } from 'semantic-ui-react';
import _ from 'lodash';
import { Field } from 'redux-form';
import classNames from 'classnames';
import 'Styles/components/filters.less';

const FiltersComponent = props => {
  const { fields, onFilterChange } = props;

  let html = [];
  let rowDiv = [];
  let length = fields.length;
  let rows = Math.ceil(length / 3);
  _.forEach(fields, function(item, index) {
    const {
      name,
      component,
      type,
      options,
      label,
      columnClassName,
      ...other
    } = item;
    const columnClass = classNames({
      [columnClassName]: columnClassName ? true : false,
    });
    html.push(
      <Grid.Column key={name} className={columnClass}>
        <Field
          name={name}
          component={component}
          type={type}
          options={options}
          label={label}
          onChange={onFilterChange}
          {...other}
        />
      </Grid.Column>
    );
    if ((index + 1) % 3 === 0) {
      rowDiv.push(
        <Grid.Row columns={3} key={name} className={'grid-spacing'}>
          {html}
        </Grid.Row>
      );
      html = [];
    } else if (length < 3 && index === length - 1) {
      rowDiv.push(
        <Grid.Row columns={length} key={name} className={'grid-spacing'}>
          {html}
        </Grid.Row>
      );
    } else if (length < 3 * rows && index === length - 1) {
      rowDiv.push(
        <Grid.Row columns={3} key={name} className={'grid-spacing'}>
          {html}
        </Grid.Row>
      );
    }
  });
  return <React.Fragment>{rowDiv}</React.Fragment>;
};

export default FiltersComponent;



// WEBPACK FOOTER //
// ./src/components/filters/component/index.js